export enum ValidationErrors {
    UsernameAlreadyExists = "User.UsernameDuplicated"
}
